import { useSignal } from '@preact/signals-react'
import { useCallback } from 'react'
import { getSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'
import { acrissTable, categoriesTable } from 'Pages/Admin/AdminMapping/@signals'
import { useToast } from '@hooks'

export default function useAdminMappingTable(path) {
	const isTableLoading = useSignal(false)
	const { showToast } = useToast()

	const getTableData = useCallback(() => {
		isTableLoading.value = true
		getSubmit(`${path === MAPPING_TYPE.ACRISS ? BACKEND_APIS.CUSTOM_ACRISS : BACKEND_APIS.CUSTOM_CATEGORY}/list`).then(res => {
			if (path === MAPPING_TYPE.ACRISS) {
				acrissTable.value = res
			} else {
				categoriesTable.value = res
			}
			isTableLoading.value = false
		}).catch(() => {
			showToast.error()
			isTableLoading.value = false
		})

	}, [])


	return {
		getTableData,
		tableData: path === MAPPING_TYPE.ACRISS ? acrissTable.value : categoriesTable.value,
		isTableLoading: isTableLoading.value,
	}
}